import { Component, OnInit, Input } from '@angular/core';
import { LoadConfigService } from '../../../services/load-config.service';
import { DecisionTransportService } from '../../../services/decision-transport.service';
import { InstructionService } from '../../../services/instruction.service';

@Component({
  selector: 'app-button-setup-two',
  templateUrl: './button-setup-two.component.html',
  styleUrls: ['./button-setup-two.component.scss'],
})
export class ButtonSetupTwoComponent implements OnInit {
  @Input('type') type: string = 'two';
  keyLabels: string[];
  decisionKeys: string[];

  constructor(
    private loadConfig: LoadConfigService,
    private decisionTransporter: DecisionTransportService,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    if(this.type === 'priming') {
      this.decisionKeys = this.loadConfig.getDecisionKeysIAT(this.type);
      this.keyLabels = this.loadConfig.getKeyLabelsIAT(this.type,
        this.instructionService.getLanguageIdentifier()
        );
    } else {
      this.decisionKeys = this.loadConfig.getDecisionKeys();
      this.keyLabels = this.loadConfig.getKeyLabels(
        this.instructionService.getLanguageIdentifier()
      );
    }
  }

  triggerDecision(decision: boolean | number | string) {
    this.decisionTransporter.decisionTriggered(decision);
  }
}
